<template>
    <div class="full-page" :class="setPageClass">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'AuthLayout',
    computed: {
        setPageClass() {
            return `${this.$route.name}-page`.toLowerCase();
        }
    }
};
</script>

<style scoped>
.full-page {
    min-height: 100vh;
    width: 100%;
}

.login-page,
.register-page,
.callback-page {
    background-color: #1c3e61;
}
</style>
